import { Button } from "@braintrust/braintrust-ui-components";
import { CannotMakeAction } from "@js/apps/jobs/components/cannot-make-action";
import type { Job } from "@js/types/jobs";

import { handleApproveTalentClick } from "../handle-approve-talent";

import style from "../style.module.scss";

type ApproveTalentButtonProps = {
  job: Job;
  isTalentApproved: boolean;
  canManageJobsOnBehalfOfClient: boolean;
  freelancerId: number;
  refetchBidList?: (() => void) | null;
  closeDrawer?: () => void;
};

export const shouldShowApproveTalentButton = (
  isTalentApproved: boolean,
  canManageJobsOnBehalfOfClient: boolean,
): boolean => {
  return !isTalentApproved && canManageJobsOnBehalfOfClient;
};

export const ApproveTalentButton = ({
  job,
  isTalentApproved,
  canManageJobsOnBehalfOfClient,
  freelancerId,
  refetchBidList,
  closeDrawer,
}: ApproveTalentButtonProps) => {
  if (
    !shouldShowApproveTalentButton(
      isTalentApproved,
      canManageJobsOnBehalfOfClient,
    )
  ) {
    return null;
  }

  return (
    <CannotMakeAction job={job}>
      <Button
        shape="squared"
        variant="info-2"
        className={style.bidCtaBtn}
        onClick={() => {
          if (refetchBidList) {
            handleApproveTalentClick(freelancerId, refetchBidList);
          }
          if (closeDrawer) closeDrawer();
        }}
        size="x-small"
      >
        Approve talent
      </Button>
    </CannotMakeAction>
  );
};
